import { useMutation, useQuery } from "@tanstack/react-query"
import instance from "../../instance"


export const useUploadDocument = () => {
    const upload= async(payload:FormData)=>{
        const {data}= await instance.post(`/documents/upload`,payload)
        return data
    }
    const mutation = useMutation({
        mutationFn:upload
    })
return mutation
}


export interface IFetchDocumentFilters{
page?:string
page_size?:string
search?:string
is_approved?:string
user_id:string | number
}
interface FetchDocumentResponse{
documents:Documents[],
page: number
page_size: number
total_documents:number 
}
interface Documents{
    id:number,
    name:string,
    user_id:string,
    doc_type:string,
    created_at:string

}
export const useFetchDocuments=(payload:IFetchDocumentFilters)=>{
    const fetchDocuments= async():Promise<FetchDocumentResponse>=>{
const {data}= await instance.get(`/documents/all/${payload.user_id}?page=${payload.page}&page_size=${payload.page_size}&search=${payload.search}&is_approved=${payload.is_approved}`)
return data

    }
    const query= useQuery({
        queryFn:fetchDocuments,
        queryKey:['documents', payload]
    })
return query
}

export const useDeleteDocument=()=>{
    const deleteDoc=async(id:number)=>{
const {data}= await instance.delete(`/documents/${id}`)
return data
    }
const mutation= useMutation({
    mutationFn:deleteDoc
})
return mutation
}